import './styles.css';
import Player, { INebulaPlayerRef, IPlayerProps } from './Player';
import { Flex } from '@chakra-ui/react';
import React from 'react';

export interface INebulaPlayer extends Omit<IPlayerProps, 'src'> {
    url: string;
}
export const NebulaPlayer = React.forwardRef<INebulaPlayerRef, INebulaPlayer>((props: INebulaPlayer, ref) => {
    const { url, project, onViewUpdate, autoPlay, onNextPress, videoStyle } = props;

    return (
        <Flex flexDir="column">
            <Player
                src={url}
                project={project}
                onViewUpdate={onViewUpdate}
                autoPlay={autoPlay}
                onNextPress={onNextPress}
                videoStyle={videoStyle}
                ref={ref}
                {...props}
            />
        </Flex>
    );
});
